import React, { useState, useEffect } from "react";
import "./TransitioningSectionForAd.css";

/* One line per ad. Add/remove/reorder here   nothing else to touch.
   (AD10 and AD11 were listed twice in the old version; duplicates removed.
   Re-add a line if repeating an ad was intentional.) */
const AD_IMAGES = [
  require("../images/AD10.jpg"),
  require("../images/AD11.jpg"),
  require("../images/AD12.jpg"),
  require("../images/AD3.jpg"),
  require("../images/AD1.jpg"),
  require("../images/AD2.jpg"),
  require("../images/AD4.jpg"),
  require("../images/AD6.jpg"),
  require("../images/AD7.jpg"),
];

const SLIDE_INTERVAL_MS = 5000;

function TransitioningSectionForAd() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % AD_IMAGES.length);
    }, SLIDE_INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="sliding-ad-carousel-container" aria-label="Sponsored ads">
      {AD_IMAGES.map((src, index) => (
        <div
          key={index}
          className="sliding-ad-slide"
          style={{ transform: `translateX(${(index - currentIndex) * 100}%)` }}
          aria-hidden={index !== currentIndex}
        >
          <div className="sliding-ad-section">
            <img src={src} alt={`Sponsored ad ${index + 1}`} className="sliding-ad-image" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default TransitioningSectionForAd;
